import { Component } from '@angular/core';
import { BaseDialogComponent } from '../../../../kit/base-dialog/base-dialog.component';
import { ButtonComponent } from '../../../../kit/button/button.component';
import { fb } from '../../../../../modules/shared/shared.global-service';
import { CheckInputComponent } from '../../../../kit/input/check-input/check-input.component';
import { RadioInputComponent } from '../../../../kit/input/radio-input/radio-input.component';
import { TextInputComponent } from '../../../../kit/input/text-input/text-input.component';

@Component({
    selector: 'app-folder-e-prescription-medication-entries-modal',
    templateUrl: 'folder-e-prescription-notification-modal.component.html',
    styleUrls: ['folder-e-prescription-notification-modal.component.scss'],
    imports: [
        ButtonComponent,
        CheckInputComponent,
        RadioInputComponent,
        TextInputComponent,
    ]
})
export class FolderEPrescriptionNotificationModalComponent extends BaseDialogComponent {
    protected types = [
        { value: 'none', name: 'types.none' },
        { value: 'sms', name: 'types.sms' },
        { value: 'mail', name: 'types.mail' },
    ];

    protected form = fb.group({
        type: fb.control<string>('none'),
        oneTime: fb.control<boolean>(false),
        mobile: fb.control<string | null>(null),
        mail: fb.control<string | null>(null),
    });

    protected prefix = 'ePrescriptions.notificationSend.form.';
}
